import { ConfigProvider, Form } from 'antd';
const { Item } = Form;

export default function InputItem({ children, ...props }) {
    return (
        <ConfigProvider getPopupContainer={trigger => trigger.parentElement}>
            <Item {...props}  >{children}</Item>
        </ConfigProvider>

    )
}
